
import { DefaultState } from 'store/types';

export const LODGING_REQUEST_REPORT_EXCEL_REQUEST = 'LODGING_REQUEST_REPORT_EXCEL_REQUEST';
export const LODGING_REQUEST_REPORT_EXCEL_SUCCESS = 'LODGING_REQUEST_REPORT_EXCEL_SUCCESS';
export const LODGING_REQUEST_REPORT_EXCEL_FAILURE = 'LODGING_REQUEST_REPORT_EXCEL_FAILURE';

export interface LodgingRequestReportExcelParams {
  reportId: string;
};

export type LodgingRequestReportExcelState = DefaultState & {
  contents?: {};
};

interface LodgingRequestReportExcelRequest {
  type: typeof LODGING_REQUEST_REPORT_EXCEL_REQUEST;
};

interface LodgingRequestReportExcelSuccess {
  type: typeof LODGING_REQUEST_REPORT_EXCEL_SUCCESS,
  contents: {};
}

interface LodgingRequestReportExcelFailure {
  type: typeof LODGING_REQUEST_REPORT_EXCEL_FAILURE;
}

export type LodgingRequestReportExcelActionTypes = LodgingRequestReportExcelRequest | LodgingRequestReportExcelSuccess | LodgingRequestReportExcelFailure;